import { createSelector } from 'reselect'
import { Shared } from 'types/Shared'
import { getShared } from './helpers'

export const getSharedIsConstructorExperience = createSelector(
  [getShared],
  ({ isConstructoExperience }: Shared): boolean => isConstructoExperience || false
)
